import React, { useRef, useEffect, useState } from "react";
import F2 from "@antv/f2/lib/index-all";
import bigNumberTransform from '../../utils/bigNumberTransform'
import './index.scss'
import _ from 'lodash';

interface Item {
    type: string
    date: string
    value: number
}

interface AilineChartProps {
    data: Item[] //图表数据
    canvasWidth?: string //图表宽度
    canvasHeight?: string //图表高度
    colors?: Array<any>
    tooltipTitle?: string
    isTooltip?: boolean
    mask?:string
}

const AiLine: React.FC<AilineChartProps> = ({ isTooltip = true, tooltipTitle = '', data = [], colors = ['rgba(6, 142, 234, 1)', 'rgba(33, 198, 155, 1)'], canvasWidth = '10rem', canvasHeight = '4.88rem', mask = 'MM.DD', ...props }) => {
    const myChart = useRef<any>()
    const canvasContainer = useRef<any>()
    const container = useRef<any>()
    const [html, setHtml] = useState<any>(``)
    let [lineChart, setLineChart] = useState(null)

    const _initRender = () => {
        if( lineChart ) {
            lineChart.clear(); // 清除
            lineChart.clearInteraction('pan') // 清除名称为 'type' 的交互行为
            lineChart = null
            setLineChart(null)
        }
        let len = [...new Set(data.map(item => item.date))].length
        const { width, height } = canvasContainer.current.getBoundingClientRect()
        let chart = new F2.Chart({
            id: myChart.current,
            width,
            height,
            pixelRatio: window.devicePixelRatio,
            padding:[20, 10, 'auto', 40]
        });
        chart.source(data, {
            date: {
                type: 'timeCat',
                mask:mask,
                range: [0, 1],
                values: len > 7 ? [...new Set(data.map(item => item.date))].slice(0, 7) : undefined
            },
            value:{
                formatter:value => (typeof value === 'number' && !isNaN(value * 1)) ? bigNumberTransform(value * 1) : value
            }
        });
        chart.axis('date', {
            label: (text, index, total) => {
                // 只显示每一年的第一天
                const textCfg: any = {};
                if (index === 0) {
                    textCfg.textAlign = 'left';
                } else if (index === total - 1) {
                    textCfg.textAlign = 'right';
                }
                return textCfg;
            },
            tickLine: {
                top: true,
                lineWidth: 1,
                stroke: '#ccc',
                length: 5,// 刻度线长度
            },
            grid: null
        });
        chart.axis('value', {
            grid: null
        });
        chart.legend(false)
        chart.tooltip({
            showCrosshairs: true,
            custom: true, // 自定义 tooltip 内容框
            onChange: ev => {
                var tooltipEl = container.current;
                var currentData = ev.items;
                const x = Math.min(...currentData.map(item => item.x))
                const y = Math.min(...currentData.map(item => item.y))
                const origin = currentData.map(item => item.origin)
                let html = tooltipTitle ? `<h1>${tooltipTitle}</h1>` : ``
                const _origin = origin.reduce((prev, curr) => {
                    !!prev.find(item => item.type === curr.type) ? prev : prev.push(curr)
                    return prev
                }, [])
                _origin.forEach(({ name, type, value }, index) => {
                    html += ` <div>
                            <i style="--color:${colors[index]}"></i><span>${value}${type || ''}</span>
                        </div>`
                });
                setHtml(html)
                tooltipEl.style.opacity = 1
                tooltipEl.style.left = x + 'px'
            },
            onHide() {
                var tooltipEl = container.current;
                tooltipEl.style.opacity = 0
            }
        })
        if (len > 7) {
            chart.interaction('pan')
            // 定义进度条
            chart.scrollBar({
                mode: 'x',
                xStyle: {
                    offsetY: 0
                }
            })
        }
        chart.line().position('date*value').color('type', colors).style({ // 统一为所有 shape 设置固定的样式
            lineWidth: .5
        })
        
        chart.area().position('date*value').color('type');
        chart.render()
        setLineChart(chart)
    }
    useEffect(() => {
        if (data.length) {
            _initRender()
        }else {
            if( lineChart ) {
                lineChart.clear(); // 清除
                lineChart.clearInteraction('pan') // 清除名称为 'type' 的交互行为
                lineChart = null
                setLineChart(null)
            }
        }
    }, [data, isTooltip, tooltipTitle])

    const unit = data.find((item, index) => index === 0 )?.type
    return <div className="chart-line-wrapper">
        {isTooltip && <div className='f2-tooltip-wrapper' ref={container} dangerouslySetInnerHTML={{ __html: html }}></div>}
        { unit && <div className="chart-line-unit"><span>{unit}</span></div>}
        <div ref={canvasContainer} style={{ width: canvasWidth, height: canvasHeight }}>
            <canvas ref={myChart} style={{ width: '100%', height: '100%' }}></canvas>
        </div>
        {props?.children}
    </div>
}


export default AiLine